import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NewsletterSharedComponent } from './newsletter.component';

@NgModule({
    declarations: [
        NewsletterSharedComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        NewsletterSharedComponent
    ]
})

export class NewsletterSharedModule {}
